import JSRouter from "adminPage/JSRouter";
import Message from "base/Message";
import queryString from "query-string";
import FormValidator from "base/FormValidator";
import Ajax from "base/Ajax";

JSRouter.register('login', new RegExp('^/?$'), () => {
    FormValidator.attach($(".js-login-form"), {inputOptions: {operator: 'your'}}).on("submit", function ($form) {
        let $btn = $form.find("button[type='submit']");
        if ($btn.is(".admin-btn--loading")) return;
        $btn.addClass("admin-btn--loading");

        Ajax.post("adminUsers", "login", {
            email: $form.find(".js-email").val(),
            password: $form.find(".js-password").val(),
            remember: $form.find(".js-remember-me").is(":checked") ? 1 : undefined
        }, Ajax.ADMIN).then(function () {
            let query = queryString.parse(window.location.search);
            if ("undefined" !== typeof query['next'] && /^\/([a-zA-Z])\/?.+/.test(decodeURI(query['next']))) {
                window.location = query['next'];
            } else {
                window.location = window.CONFIG.login.redirectUrl;
            }
        }, function (e) {
            new Message(e.message, "Couldn't log you in");
            $btn.removeClass("admin-btn--loading");
        })
    });

    $("body").on("change", ".js-show-password", function () {
        $(".js-password").attr("type", $(this).is(":checked") ? 'text' : 'password');
    }).on("keydown", ".js-email", function (e) {
        if (e.which === 9 && !e.shiftKey) {
            $(".js-password").focus();
            return false;
        }
    }).on("keydown", ".js-password", function (e) {
        if (e.which === 9 && e.shiftKey) {
            $(".js-email").focus();
            return false;
        }
    });
});
